module.exports = __webpack_public_path__ + "img/banner.abe8b11f.jpg";